// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"_1gZ1tnH908wzjSgZFilwvo","messageContainer":"_23an5RzobsUh4_8-hExN2u","message":"_2JN3cZzjKscDxsjqrPw1VO","content":"_2RM4-A0f5yVB5v2UL9S2Aj","animatedEnter":"TuHAiMWI_ct4a4GX39ugR","animatedEnterActive":"_1aBm_p-8TFRMu9AOoWBMS2","showNotification":"_33fkksFvcgkNn-IjcstBiA","animatedExit":"_3_E-nqK1mJi6Ctjxr2wXAW","animatedExitActive":"_3_GFKsQSPy13c3cvVmkfwM","hideNotification":"_2rvCtyiX1MLOvEBiu9mXO_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationsModal/style.css
// module id = 542
// module chunks = 0